export type FrontendUserRole =
  | 'super-admin'
  | 'admin'
  | 'auditor'
  | 'user'

export interface UserRoleItem {
  role?: string
  roleKey?: string
  scope?: string
  product?: string
  isActive?: boolean
}

const normalizeRole = (role?: string): string => {
  return role
    ?.trim()
    .toLowerCase()
    .replaceAll('-', '_') ?? ''
}

export const resolveUserRole = (
  roles?: UserRoleItem[]
): FrontendUserRole => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return 'user'
  }

  const activeRoles = roles
    .filter((roleItem) => roleItem.isActive !== false)
    .map((roleItem) => normalizeRole(roleItem.role))

  if (activeRoles.includes('primary_user')) {
    return 'super-admin'
  }

  if (
    activeRoles.includes('admin') ||
    activeRoles.includes('preparer')
  ) {
    return 'admin'
  }

  if (activeRoles.includes('auditor')) {
    return 'auditor'
  }

  return 'user'
}